<template>
    <div class="d-flex wrapper align-center justify-end" v-if="getTotalPages">
        <v-select
            :items="numberPages()"
            item-text="label"
            item-value="index"
            rounded
            @change="change"
            dense
            color="white"
            :label="pageLabel"
            v-model="reSetCurrentPage"
            solo
            class="select-pagination"
        ></v-select>
        <v-btn
            icon
            color="gray"
            @click="previous()"
            :disabled="disablingPrev"
            title="Anterior"
        >
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
            icon
            color="gray"
            @click="next()"
            :disabled="disablingNext"
            title="Siguiente"
        >
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
        pages: {
            type: Number
        },
        getData: {
            type: Function,
            required: true
        },
        pageSize: {
            type: Number,
            default: 8
        }
    },
    data() {
        return {
            filter: null,
            pageCurrent: 0,
            pageLabel: "1",
            disableNext: false,
            disablePrev: false
        };
    },
    computed: {
        ...mapGetters({
            getCurrentPage: "getCurrentPage"
        }),
        getTotalPages() {
            return this.pages;
        },
        reSetCurrentPage: {
            get() {
                return this.getCurrentPage;
            },
            set(val) {
                return this.setCurrentPage(val);
            }
        },
        disablingNext() {
            const disable =
                this.getTotalPages <= 1 ||
                this.getTotalPages === this.getCurrentPage + 1;
            return disable;
        },
        disablingPrev() {
            const disable = this.getCurrentPage === 0;
            return disable;
        }
    },
    async mounted() {
        this.getData({ pageNumber: 0, pageSize: this.pageSize });
    },
    methods: {
        ...mapActions({
            setCurrentPage: "setCurrentPage"
        }),
        // load array with pages for select
        numberPages() {
            const pages = [];
            for (let index = 0; index < this.getTotalPages; index++) {
                pages.push({ index: index, label: index + 1 });
            }
            return pages;
        },
        // event on detect change in select
        change() {
            this.getData({
                pageNumber: this.getCurrentPage,
                pageSize: this.pageSize
            });
        },
        //  next page list
        next() {
            const nextPage = this.getCurrentPage + 1;
            this.setCurrentPage(nextPage);
            this.getData({
                pageNumber: nextPage,
                pageSize: this.pageSize
            });
        },
        // previos page list
        previous() {
            const prevPage = this.getCurrentPage - 1;
            this.setCurrentPage(prevPage);
            this.getData({
                pageNumber: prevPage,
                pageSize: this.pageSize
            });
        }
    }
};
</script>

<style lang="scss">
.pagination-component {
}
</style>
